import { inject, type InjectionKey } from "vue";
import type { AppConfig } from "./types";

export const configKey: InjectionKey<AppConfig> = Symbol("config");

export function useConfig(): AppConfig {
  const config = inject(configKey);
  if (!config) {
    throw new Error("Config not installed. Did you forget app.provide(configKey, ...) in main.ts?");
  }
  return config;
}
